// The design measures the footer to the top of the home indicator, which only the
// insets know the height of; the floor stands in on a device without one.
const FOOTER_GAP = 16
const FOOTER_MIN = 24

/** What a full-window step's footer keeps between itself and the screen edge. */
export function footerBottomMargin(bottomInset: number): number {
  return Math.max(FOOTER_GAP + bottomInset, FOOTER_MIN)
}
